import React from "react";

import { SpinnerIcon } from "@/assets/icons";

import { twMerge } from "tailwind-merge";

interface LoadingWrapperProps {
  isLoading: boolean;
  loadingClassName?: string;
  children?: React.ReactNode;
  loadingText?: string | React.ReactNode;
  /**
   * When true, keep `children` mounted and render the spinner as an overlay on
   * top of them. The loading area then follows the children's height instead of
   * a fixed box. Defaults to false (spinner replaces children).
   */
  overlay?: boolean;
}

function LoadingWrapper({
  isLoading,
  loadingClassName,
  children,
  loadingText,
  overlay = false
}: Readonly<LoadingWrapperProps>) {
  // Overlay mode: children define the height, spinner sits on top while loading.
  if (overlay) {
    return (
      <div className="relative">
        {children}
        {isLoading && (
          <div
            className={twMerge(
              "absolute inset-0 z-10 flex-center bg-white/70",
              loadingClassName
            )}
          >
            <SpinnerIcon className="spin-animation" />
            {loadingText}
          </div>
        )}
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className={twMerge("flex-center h-[200px]", loadingClassName)}>
        <SpinnerIcon className="spin-animation" />
        {loadingText}
      </div>
    );
  }

  return <>{children}</>;
}

export default LoadingWrapper;
